import { render, staticRenderFns } from "./employeeRole.vue?vue&type=template&id=2d38483e&scoped=true"
import script from "./employeeRole.vue?vue&type=script&lang=js"
export * from "./employeeRole.vue?vue&type=script&lang=js"
import style0 from "./employeeRole.vue?vue&type=style&index=0&id=2d38483e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d38483e",
  null
  
)

export default component.exports